module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/hospital_detail/img_article-90aa2478dadeaa3c5aab4d79d6d65dd6.jpg";